import React from "react";
import { observer } from "mobx-react-lite";
import { useDragLayer } from "react-dnd";
import CarouselSlidePreview, { HERO_SLIDE_DND_TYPE } from "./hero-slide-preview";
import { IHeroSlide } from "../../../../types/content-block-data";

interface ISlideDragPreviewProps {
  slide: IHeroSlide;
}

export default observer(function SlideDragPreview ({ slide } : ISlideDragPreviewProps) {
  const {
    item,
    itemType,
    currentOffset,
    isDragging,
  } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (!isDragging || !currentOffset || itemType !== HERO_SLIDE_DND_TYPE || item == null) {
    return null;
  }
	const { x, y } = currentOffset;

	console.log("x: " + x + ", y: " + y);

	const layerStyles: React.CSSProperties = {
		position: "fixed",
		borderLeftWidth: "0px",
		borderRightWidth: "0px",
		borderColor: "white",
		pointerEvents: "none",
		top: "-55px",
		left: "-75px",
		cursor: "grabbing",
		zIndex: 100,
		transform: `translate(${x}px, ${y}px) rotate(-4deg) scale(1.08)`,
    filter: "drop-shadow(0 8px 30px rgba(60, 120, 255, 0.20))",
    opacity: 0.98,
	};

  return (
    <div style={{ ...layerStyles }}>
      <div
        className={`
          w-[120px] h-[80px] rounded-md overflow-hidden 
          shadow-2xl border-2 border-blue-400 
          bg-gray-100 
          pointer-events-none
        `}
        style={{
          opacity: 0.98,
        }}
      >
        <img
          src={slide.slideImage?.src}
          alt={slide.slideImage?.alt || ""}
          className="w-full h-full object-cover"
          draggable={false}
          style={{ pointerEvents: "none" }}
        />
      </div>
    </div>
  );
});